import styled from 'styled-components';

export const TabsStyled = styled.div<{
  $activeTabColor?: string;
  $transparentBackground?: boolean;
}>`
  & .tabs-label-container {
    display: flex;
    align-items: center;
    // justify-content: space-between;
    gap: 36px;
    background-color: ${({ theme, $transparentBackground }) =>
      $transparentBackground ? 'transparent' : theme.colors.disable};

    & .tab {
      position: relative;
      min-width: fit-content;
      cursor: pointer;
      padding: 10px 16px;
      text-align: center;
      &::after {
        content: '';
        position: absolute;
        bottom: 0px;
        left: 0px;
        right: 0px;
        height: 3px;
        color: ${({ $activeTabColor }) => $activeTabColor || '#000000'};
        transition: all 0.3s;
        border-bottom: 3px solid ${({ theme }) => theme.colors.transparent};
      }
      &.underline-active {
        color: ${({ $activeTabColor, theme }) =>
          $activeTabColor || theme.colors.secondary};

        &::after {
          border-color: ${({ theme }) => theme.colors.secondary};
        }
      }
      &.label-active {
        color: ${({ $activeTabColor, theme }) =>
          $activeTabColor || theme.colors.secondary};
      }
    }
  }

  & .tabs-content-container {
    width: 100%;
  }
`;
